import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = user
  const [twoFactor, setTwoFactor] = useState(null); // {challenge_token} when needed

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    })();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (data.two_factor_required) {
      setTwoFactor({ challenge_token: data.challenge_token });
      return { needs2fa: true };
    }
    setUser(data);
    setTwoFactor(null);
    return { needs2fa: false };
  };

  const login2fa = async (code) => {
    const { data } = await api.post("/auth/login/2fa", {
      challenge_token: twoFactor.challenge_token, code,
    });
    setUser(data);
    setTwoFactor(null);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  return (
    <AuthCtx.Provider value={{ user, login, login2fa, logout, twoFactor, setTwoFactor, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
